import { TAPPAY } from '../libs/constants'
import * as types from './actionTypes'

/*
payload: {
  "member_id": 200227,  // 會員/訪客編號
  "cream_item_id": "5c9207e066b002d94c48b58cac8fba5020e94be6b0b068d9f3334435",  // 商品ID
  "prime": "4e2b530bd6aaee953d78b3a469296f11ce225fcc75e3775e54a90acdafc8000c", // TapPay交易用的一次性token (每呼叫一次API需產生一組新的token)
  "qty": 1,
	"contact_name": "派崔克",  // 聯絡人姓名 (非 aifian 用戶才需填寫)
	"contact_email": "patrick@gmail.com", // 聯絡人電子信箱 (非 aifian 用戶才需填寫)
  "timezone": "Asia/Taipei",
  "cash_discount": 120,    // "Slash收款"折抵金額 (Slash收款+Slash回饋=Slash折抵金額)
  "reward_discount": 160,  // "Slash回饋"折抵金額 (Slash收款+Slash回饋=Slash折抵金額)
  "token_discount": 35,    // "我的回饋"折抵金額
  "in_app": true  // 是否為App (optional: 預設為false)
}
 */
export const checkoutTapPayAction = payload => {
  const action = {
    type: types.CHECKOUT_TAPPAY,
    payload,
  }
  return action
}

export const checkoutTapPayErrorAction = (failed, errno, stayAtPurchase) => ({
  type: types.CHECKOUT_TAPPAY_ERROR,
  payload: { failed, errno, stayAtPurchase },
})

export const checkoutTapPayInstalmentAction = payload => ({
  type: types.CHECKOUT_TAPPAY_INSTALMENT,
  payload,
})

/*
 定期定額付款 
 payload: { order_number, prime }
 */
export const checkoutTapPayPeriodicAction = payload => ({
  type: types.CHECKOUT_TAPPAY_PERIODIC,
  payload,
})

export const clearPurchaseResultAction = () => ({
  type: types.CLEAR_PURCHASE_RESULT,
})

export const loadTapPaySDKAction = ({ itemId, orderNo }, guest = null) => {
  const payload = {
    memberQuery: {
      itemId,
      orderNo,
    },
    url: TAPPAY.SDK_URL,
    id: 'tpsdkurl',
  }
  if (guest) {
    const { itemId, orderNo, member_id, mobile } = guest
    const orderInfo = itemId
      ? { cream_item_id: `${itemId}` }
      : { order_no: `${orderNo}` }

    payload.guest = {
      ...orderInfo,
      member_id,
      mobile,
    }
    // payload.memberId = guest.memberId
    // payload.mobile = guest.mobile
  }
  return {
    type: types.LOAD_TAPPAY_SDK,
    payload,
  }
}
